import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import moment from 'moment';
import { UnitPrice } from '@/types';

@Component
export default class UnitPrices extends Vue {
    private unitPriceList: UnitPrice[] = []
    @Prop()
    private title!: string

    @Prop()
    private unitPrices!: UnitPrice[]

    private created() {
        this.unitPriceList = this.sortList(this.unitPrices)
    }

    public getUnitPrices() {
        const errmsg: string[] = []

        // 単価が負の値でないかチェックして負の値だったらエラーメッセージを返す
        if(this.unitPriceList.filter(item => item.cost == undefined || !/^([1-9]\d*|0)$/.test(item.cost.toString())).length != 0) {
            errmsg.push('単価は0以上の値を入力してください')
        }
        // 日付の重複チェックをして重複をしていたらエラーメッセージを返す
        const list = this.unitPriceList.filter((item, index, self) =>
            self.findIndex(i => item.from == i.from) == index
        )
        if(list.length != this.unitPriceList.length) {
            errmsg.push('単価に同じ期日を複数指定することはできません')
        }

        if(errmsg.length > 0) {
            return errmsg
        } else {
            return this.unitPriceList
        }
    }

    private addUnitPrice() {
        let fromDate
        let from = ''
        if(this.unitPriceList.length !== 0) {
            fromDate = new Date(this.unitPriceList[0].from)
            from = moment(fromDate.setDate(fromDate.getDate() + 1)).format('YYYY-MM-DD')
        }else {
            fromDate = new Date()
            from = moment(fromDate).format('YYYY-MM-DD')
        }
        this.unitPriceList.push({
            from: from
        })
        this.sortList(this.unitPriceList)
    }

    private removeUnitPrice(index: number) {
        this.unitPriceList.splice(index, 1)
    }

    private sortList(list: UnitPrice[]) {
        return list.sort((a: UnitPrice, b: UnitPrice) => {
            if (a.from > b.from) {
                return -1;
            } else {
                return 1;
            }
        })
    }

    private unitPriceTo(index: number) {
        if (index == 0) {
            return
        } else {
            if(this.unitPriceList[index].from == this.unitPriceList[index - 1].from) {
                const date = this.unitPriceList[index - 1].from
                return  date.replace(/-/g, '/')
            }else {
                const fromDate = new Date(this.unitPriceList[index - 1].from)
                return moment(fromDate.setDate(fromDate.getDate() - 1)).format('YYYY/MM/DD')
            }
        }
    }
    private onChangeUnitPrice() {
        this.unitPriceList = this.sortList(this.unitPriceList)
    }
    
    public cleanUnitPrices() {
        this.unitPriceList = []
    }
}